import React, { useEffect, useState } from "react";
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';

export default function AddGoods({chosenGoods, setChosenGoods, availableGoods}) {

    function findGoodsById(id) {
        return availableGoods.find((element) => {
            return element.goodsId === id;
        })
    }

    const handleGoodsSelect = (e, index) => {                             //функция, которая вызывается после выбора работы из дропдауна
        const list = [...chosenGoods];
        list[index].goodsId = e.target.value;
        list[index].price = findGoodsById(e.target.value).price;
        list[index].salary = findGoodsById(e.target.value).salary;
        setChosenGoods(list);
    };

    const handleGoodsNumberSelect = (e, index) => {                             //функция, которая вызывается после выбора работы из дропдауна
        const result = e.target.value.replace(/\D/g, '');
        const list = [...chosenGoods];
        list[index].goodsNumber = result;
        setChosenGoods(list);
    };

    const handleRemoveGoods = (index) => {                               //функция, которая вызывается при удалении товара
        const list = [...chosenGoods];
        list.splice(index, 1);
        setChosenGoods(list);
        console.log("remove");
    };
    
    const handleAddGoods = () => {                                       //функция, которая вызывается при добавлении товара
        setChosenGoods([...chosenGoods, {serviceId: availableGoods[0].goodsId, goodsNumber: 1, price: availableGoods[0].price, salary: availableGoods[0].salary}]);     //при добавлении нового сервиса - автоматически подставляется первый товар из списка
        console.log("add");
    };
   
    return (
        <Box sx={{ maxWidth: 400, margin: `auto`, pt: 1}}>
        <div className="modal-form">
            <label className="add-service-header">Выберите товары:</label>
            {chosenGoods && chosenGoods.map((x, i) => (                             //создаем select по количеству выбранных товаров
            <div key={i}>
                <FormControl sx={{mb:1.5, mt:1.5}} fullWidth >
                <InputLabel id="demo-simple-select-label">Название:</InputLabel>
                <Select
                    key = {i+1}
                    value={chosenGoods[i].goodsId}
                    label="Название:"
                    name="goodsChoosing"
                    size="small"
                    fullWidth
                    onChange={e => handleGoodsSelect(e, i)}
                >
                    {availableGoods && availableGoods.map(({goodsId, goodsName, goodsCategory}) => (                           //листим каталог работ
                    <MenuItem key={goodsId} value={goodsId}> {goodsName} </MenuItem>
                    ))}
                </Select>
                </FormControl>

                <TextField
                    variant="outlined"
                    key = {i+2}
                    value={chosenGoods[i].goodsNumber}
                    label="Количество:"
                    name="goodsNumber"
                    size="small"
                    sx={{mb:1.5, mt:1.5}}
                    fullWidth
                    onChange={e => handleGoodsNumberSelect(e, i)}
                />

                {chosenGoods.length>1 && <Button variant="text" color="error" size="small" sx={{ mb: 1 }} onClick={() => handleRemoveGoods(i)}>Удалить</Button>}
            </div>
            ))}
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
            <Button name="addGoodsButton" variant="outlined" size="small" onClick={handleAddGoods}>Добавить товар</Button>
            </Box>
        </div>
        </Box>
    );
}